const max = {
  largeDesktop: '(max-width: 1690px)',
  desktop: '(max-width: 1280px)',
  tablet: '(max-width: 980px)',
  phone: '(max-width: 736px)',
  smallPhone: '(max-width: 480px)'
};

export const breakpoints = {
  max
};

export type Breakpoints = typeof breakpoints;
